import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusSquare, faMinusSquare } from "@fortawesome/free-solid-svg-icons";

const Accordion = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(true);
  const contentRef = useRef(null);
  const [height, setHeight] = useState(300);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    setTimeout(() => {
      setHeight(contentRef.current?.scrollHeight || 300);
    }, 100);
  }, []);

  return (
    <div className="accordion-item">
      <button className="accordion-toggle" onClick={toggleAccordion}>
        <span style={{ width: 20 }}>
          <FontAwesomeIcon icon={isOpen ? faMinusSquare : faPlusSquare} />
        </span>
        <span className="text-center">{title}</span>
        <span></span>
      </button>
      <div
        className={`accordion-content ${isOpen ? "open" : ""}`}
        ref={contentRef}
        style={{
          maxHeight: isOpen ? `${height + 20}px` : "0px",
          padding: isOpen ? "16px" : "0",
          overflow: "hidden",
          transition: "all 0.3s ease-in-out",
        }}
      >
        <div
          style={{
            paddingTop: "8px",
            paddingLeft: "16px",
            paddingRight: "16px",
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default Accordion;
